import React from 'react';
import chevLeft from 'icons/chevron-left-24.png';
import { useNavigate } from 'react-router-dom';
import { getAllData } from 'store/idb';

export default function ExportAll() {
  console.log('ExportAll');
  const navigate = useNavigate();

  async function loadAllData() {
    const users = await getAllData('users');
    let userData = '"users":';
    userData += JSON.stringify(users);
  
    const meds = await getAllData('medications');
    let medsData = '"medications":';
    medsData += JSON.stringify(meds);
    
    const hist = await getAllData('history');
    let histData = '"history":';
    histData += JSON.stringify(hist);

    const cond = await getAllData('conditions');
    let condData = '"conditions":';
    condData += JSON.stringify(cond);

    const supps = await getAllData('supplements');
    let suppsData = '"supplements":';
    suppsData += JSON.stringify(supps);

    const ings = await getAllData('ingredients');
    let ingData = '"ingredients":';
    ingData += JSON.stringify(ings);


    let json = '{';
    json += userData;
    json += ',';
    json += medsData;
    json += ',';
    json += histData;
    json += ',';
    json += condData;
    json += ',';
    json += suppsData;
    json += ',';
    json += ingData;
    json += '}';
    //  console.log(json);
    return json;
  }

  async function handleExport() {
    const json = await loadAllData();
    //console.log(json);
    exportData(json);
  }

  function exportData(data) {
    const jsonString = `data:text/json;chatset=utf-8,${data}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "itookitwhen.json";
    link.click();
  };

  return (
    <div className='mcard'>
      <div className='mcard-screen flex justify-between h-100'>
        <div className='hover:cursor-pointer' onClick={()=>navigate(-1)}>
          <img src={chevLeft} alt='' />
        </div>
        <div className='w-full pl-4'>
          <div className='text-xl '>Export All Data to JSON</div>
        </div>
      </div>
      <div className='w-full h-full pt-40 flex justify-center'>
        <button 
          className='rawBtn w-60 h-8 bg-blue-400'
          onClick={()=>handleExport()}
        >
          Export All Data
        </button>
      </div>
    </div>
  );
}
